module.exports = __webpack_public_path__ + "img/Wp_2022.37218952.png";